"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FacebookIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("../../SvgIcon"));

var _ref = /*#__PURE__*/_react.default.createElement("path", {
  d: "M20,0V20M0,20V0M19,9.5A9,9,0,1,0,8.59,18.39V12.1H6.31V9.5H8.59v-2A3.18,3.18,0,0,1,12,4a14.32,14.32,0,0,1,2,.17V6.41H12.87a1.29,1.29,0,0,0-1.46,1.4V9.5H13.9l-.4,2.6H11.41v6.29A9,9,0,0,0,19,9.5Z"
});

function FacebookIcon(props) {
  return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    viewBox: "0 0 20 20"
  }, props), _ref);
}

FacebookIcon.displayName = 'FacebookIcon';
FacebookIcon.defaultProps = {
  color: '#1877f2'
};